import React, {Component, PropTypes} from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import withWidth, {LARGE} from 'material-ui/utils/withWidth'
import spacing from 'material-ui/styles/spacing'
import typography from 'material-ui/styles/typography'
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import {cyan500, grey200, darkWhite} from 'material-ui/styles/colors'
import FullWidthSection from '../components/FullWidthSection'
import {setConfig} from '../actions'
import locale from '../locale'

class HomePage extends Component {

  static propTypes = {
    width: PropTypes.number.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  }
  componentWillMount() {
    this.context.store.dispatch(setConfig('title',null))
  }

  handleTouchTapLang = () => {
    locale.toggle()
    this.context.store.dispatch(setConfig('lang',locale.lang))
  }

  homePageHero() {
    const styles = {
      root: {
        backgroundColor: cyan500,
        overflow: 'hidden',
        // minHeight:window.innerHeight-64,
        // minHeight:window.innerHeight-96,
      },
      svgLogo: {
        display: 'block',
        margin: '0 auto',
        width: 200,
        height: 200,
      },
      tagline: {
        margin: '16px auto 0 auto',
        textAlign: 'center',
        maxWidth: 575,
      },
      label: {
        color: lightBaseTheme.palette.primary1Color,
      },
      actionBotton: {
        margin: 32,
      },
      h1: {
        color: darkWhite,
        // fontWeight: typography.fontWeightLight,
        fontWeight: 500,
        padding:16,
        marginBottom:32,
      },
      h2: {
        fontSize: 20,
        lineHeight: '28px',
        paddingTop: 19,
        // marginBottom: 13,
        letterSpacing: 0,
      },
      nowrap: {
        whiteSpace: 'nowrap',
      },
      taglineWhenLarge: {
        marginTop: 32,
      },
      h1WhenLarge: {
        fontSize: 56,
      },
      h2WhenLarge: {
        fontSize: 24,
        lineHeight: '32px',
        paddingTop: 16,
        marginBottom: 12,
      },
      badge: {
        width:200,
        margin:16,
      },
    }

    styles.h2 = Object.assign({}, styles.h1, styles.h2)

    if (this.props.width === LARGE) {
      styles.tagline = Object.assign({}, styles.tagline, styles.taglineWhenLarge)
      styles.h1 = Object.assign({}, styles.h1, styles.h1WhenLarge)
      styles.h2 = Object.assign({}, styles.h2, styles.h2WhenLarge)
    }

          // <h2 style={styles.h2}>{locale.R.sbutitle}</h2>

    return (
      <FullWidthSection style={styles.root}>
        <img style={styles.svgLogo} src="images/longdong.png" />
        <div style={styles.tagline}>
          <h1 style={styles.h1}>{locale.R.title}</h1>

          <div>
            <RaisedButton
              style={styles.actionBotton}
              label={locale.R.news}
              onTouchTap={this.handleTouchTapNews}
              labelStyle={styles.label}
            />

            <RaisedButton
              style={styles.actionBotton}
              label={locale.R.changeLang}
              onTouchTap={this.handleTouchTapLang}
              labelStyle={styles.label}
            />
          </div>

          <a href='https://play.google.com/store/apps/details?id=org.climbio.longdong'>
            <img style={styles.badge} src='images/google-play-badge.png'/>
          </a>
          <a href='https://itunes.apple.com/us/app/long-dong-long-dong/id1114278302'>
            <img style={styles.badge} src='images/app-store-badge.svg'/>
          </a>
        </div>
      </FullWidthSection>
    )
  }

  homePurpose() {
    const style = {
        width: '100%',
        padding: 0,
        margin: 0,
        marginBottom: -8,//wr for unkonw white region
    }

    return (
      <a href="https://www.facebook.com/TaiwanRebolt" target="_blank">
        <img style={style} src="images/ad2.png"/>
      </a>
    )
  }

  handleTouchTapNews = () => {
    this.context.router.push('/news')
  }
  render() {
    const style = {
      paddingTop: spacing.desktopKeylineIncrement,
    }
    return (
      <div style={style}>
        {this.homePageHero()}
        {this.homePurpose()}
      </div>
    )
  }
}

export default withWidth()(HomePage)



/** WEBPACK FOOTER **
 ** ./src/app/containers/HomePage.js
 **/